import { render, staticRenderFns } from "./Add-User.vue?vue&type=template&id=75c04803&"
import script from "./Add-User.vue?vue&type=script&lang=js&"
export * from "./Add-User.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports